<template>
    <div class="mS" style="height:100%">
        <el-input
        v-model="inputValue"
        class="isIput"
        placeholder="请输入关键词，搜索您想要查找的内容"
        :suffix-icon="Search"
        @focus="inputClick"
        @click.stop="inputClick"
        @input="changeSearch"
        >
            <template #prefix>
                    <!-- <i class="iconfont" style="font-size:22px;font-weight:500;color:#000;">&#xe614;</i> -->
                    <img style="width:16px;" src="../../assets/img/pcSearch.png" alt="">
            </template>
        </el-input>
        <!-- <div class="searchBox" :style="{'height':searchMaxBox+'px'}" > -->
        <!-- </div> -->
    </div>
</template>
<script>
import { defineComponent, reactive, toRefs } from 'vue'
import { Search } from '@element-plus/icons-vue'
export default defineComponent({
    components:{Search},
    setup(prop,{emit}) {
        const state= reactive({
            inputValue:'',
            searchMaxBox:window.innerHeight*0.4,
        })
        const methods=reactive({
            changeSearch:(val)=>{
                emit('changeSearchValue',val)
            },
            inputClick:()=>{
                emit('searchClick')
            }
        })
        return{
            ...toRefs(state),
            ...toRefs(methods)
        }
    },
})
</script>
<style lang="scss" scoped>
    .mS{
        width: 100%;
        height: 100%;
        position: relative;
        display: flex;
        justify-content: center;
        
        .el-input{
            width: 100%;
            height: 100%;
            ::v-deep .el-input__wrapper{
                border-radius: 25px;
                // border: 1px solid rgba(210,217,226,1);
                // box-shadow: 0px 2px 10px 2px #CFE2FFFC !important;
            }
        }
        .searchBox{
            position:absolute;
            top:60px;
            width:100%;
            // height:200px;
            z-index: 10;
            border:1px solid red;
            background: #fff;
            overflow-y: auto;
        }
        .secarch-btn{
            width: 41px;
            height: 32px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 16px;
            margin-right: -5px;
            // border-radius: 100px 0px 0px 0px;
            background: linear-gradient(92.12deg, rgba(32, 159, 255, 0.8) 0.89%, rgba(0, 113, 246, 0.8) 82.66%);
        }
    } 
    ::v-deep .isIput .el-input__inner{
        color: #5F6367;
        font-family: PingFang SC;
        font-size: 12px;
        font-weight: 400;
        line-height: 17px;
    }
    ::v-deep .isIput .el-input__inner::placeholder{
        color: #5F6367;
        font-family: PingFang SC;
        font-size: 12px;
        font-weight: 400;
        line-height: 17px;
    }
</style>

